import React from 'react';

import { link } from '@aline/routes';
import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUserQuery } from 'src/gql';
import { Apollo } from 'src/gql/generated';

/**
 * Layout route that restricts its child routes to org admins. Admin-only pages
 * (Data Migration, Upgrade Requests, …) back onto server resolvers that reject
 * non-admins, so without this guard a non-admin reaching the URL directly or via
 * a restored tab would just hit an error. Waits for the current user to load
 * before deciding, so admins deep-linking on a cold load aren't misredirected.
 */
export function AdminOnlyRoute(): JSX.Element | null {
  const { currentUser, loading } = useCurrentUserQuery();
  if (loading) return null;
  if (currentUser?.role !== Apollo.OrgRole.Admin) {
    return <Navigate replace to={link.AdminOrgIndex()} />;
  }

  return <Outlet />;
}
